export const INTERSTITIAL_SELECT_PROFILE = 'SELECT_PROFILE'
export const INTERSTITIAL_LOADING = 'LOADING'
